.scrim {
  position: fixed;
  inset: 0;
  z-index: var(--z-drawer);
  background: var(--scrim);
  animation: fade var(--motion-duration) var(--motion-ease);
}

/* The mockup's mobile `.sidebar` (280px) and `.rdrawer` (320px), floating with the dialog shadow. */
.drawer {
  position: fixed;
  inset-block: 0;
  z-index: var(--z-drawer);
  display: flex;
  flex-direction: column;
  min-block-size: 0;
  max-inline-size: calc(100vw - 48px);
  background: var(--surface-raised);
  color: var(--text);
  box-shadow: var(--shadow-dialog);
  animation: slide-in var(--motion-duration) var(--motion-ease);
}

.right {
  inset-inline-end: 0;
  inline-size: 320px;
  border-inline-start: 1px solid var(--border);
}

/* Owner round 3: the diagram and the details need room. */
.right.wide {
  inline-size: min(720px, 55vw);
}

@media (max-width: 767.98px) {
  .right.wide {
    inline-size: calc(100vw - 48px);
  }
}

.left {
  inset-inline-start: 0;
  inline-size: 280px;
  border-inline-end: 1px solid var(--border);
  --slide-from: -100%;
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  block-size: var(--layout-topbar);
  padding: 0 var(--space-2) 0 var(--space-4);
  border-bottom: 1px solid var(--border);
}

.title {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.close {
  display: inline-flex;
}

.body {
  flex: 1;
  overflow: auto;
  padding: var(--space-4);
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slide-in {
  from {
    transform: translateX(var(--slide-from, 100%));
  }

  to {
    transform: none;
  }
}

.headless {
  border-inline-end: 0;
}
